import radii from '../primitives/radii'

const input = {
    base: radii.none,
}
const button = {
    base: radii.none,
    rounded: radii.full,
}
const modal = {
    base: radii.none,
}

export {input, button, modal}
